'use client';

import { usePathname } from 'next/navigation';
import useMicroFrontend from '@/common/MicroFrontEnds';
import { isHomePathname } from '~/constants/common/homeAppRouter';
import { type LoadMfeGlobalsInParallelConfig } from '~/contracts/common/Configuration';

function getShouldLoadGlobalsInParallel(
  pathname: string | null,
  loadGlobalsInParallelByPage: LoadMfeGlobalsInParallelConfig
): boolean {
  if (!pathname) return false;

  if (isHomePathname(pathname)) {
    return loadGlobalsInParallelByPage.home === true;
  }

  if (pathname.startsWith('/cars')) {
    return loadGlobalsInParallelByPage.srp === true;
  }

  if (/^\/vehicle\/\d/.test(pathname)) {
    return loadGlobalsInParallelByPage.vdp === true;
  }

  return false;
}

type OwnProps = {
  debug: boolean;
  loadGlobalsInParallelByPage: LoadMfeGlobalsInParallelConfig;
};

/**
 * Client Component for MicroFrontend initialization
 * Used by MicroFrontendInitializer server component
 */
export default function MicroFrontendClient({
  debug,
  loadGlobalsInParallelByPage
}: OwnProps) {
  const pathname = usePathname();

  useMicroFrontend(
    debug,
    getShouldLoadGlobalsInParallel(pathname, loadGlobalsInParallelByPage)
  );

  return null;
}
